import { theme } from '@hhgtech/hhg-components'
import styled from 'styled-components'

export const StyledSeeMoreWrapper = styled.button`
  font-size: 14px;
  font-weight: bold;
  color: ${theme.colors.primaryBase};
  display: flex;
  align-items: center;

  &:hover {
    cursor: pointer;
  }

  * {
    pointer-events: none;
  }
`
export const StyledText = styled.span``
